<script>
import InfoBlock from '@/components/Launchpad/InfoBlock';
import { amountFilter } from '../../helpers/filters';

export default {
  name: 'SaleStageData',
  components: {
    InfoBlock,
  },
  props: {
    currentStage: {
      type: Number,
      default: 0,
    },
    info: {
      type: Object,
      default: () => {},
    },
    isBinance: {
      type: Boolean,
      default: false,
    },
    hasClaim: {
      type: Boolean,
      default: false,
    },
    stakeToken: {
      type: String,
      default: 'milk2',
    },
  },
  computed: {
    token() {
      return this.stakeToken.toUpperCase();
    },
  },
  methods: {
    amountFilter,
  },
};
</script>

<template>
  <div>
    <v-row v-if="(currentStage > 3 && !isBinance) || (currentStage > 3 && !hasClaim)">
      <v-col cols="12">
        <InfoBlock
          :label="$t('upcoming.tokens-bought')"
          :data="`${amountFilter(isNaN(info.tokensBought) ? 0 : info.tokensBought, 5)} ${
            info.token || '...'
          }`"
          class="staking-card--inline"
        />
      </v-col>
    </v-row>
    <v-row v-else-if="currentStage > 3">
      <v-col sm="4" cols="12">
        <InfoBlock
          :label="$t('upcoming.tokens-bought')"
          :data="`${amountFilter(isNaN(info.tokensBought) ? 0 : info.tokensBought, 5)} ${
            info.token || '...'
          }`"
        />
      </v-col>
      <v-col sm="4" cols="12">
        <InfoBlock
          :label="$t('upcoming.claimed-so-far')"
          :data="
            info.isClaimed
              ? `${amountFilter(info.tokensBought, 5)} ${info.token}`
              : `${amountFilter('0', 4)} ${info.token}`
          "
        />
      </v-col>
      <v-col sm="4" cols="12">
        <InfoBlock
          :label="$t('upcoming.left-to-claim')"
          :data="
            info.isClaimed
              ? `${amountFilter('0', 4)} ${info.token}`
              : `${amountFilter(isNaN(info.tokensBought) ? 0 : info.tokensBought, 5)} ${info.token}`
          "
        />
      </v-col>
    </v-row>
    <v-row v-else-if="currentStage != 0">
      <v-col sm="6" cols="12">
        <InfoBlock
          :label="$t('upcoming.rate')"
          :data="`1 ${info.token || '...'} = ${info.tokenPrice} ${info.paymentToken || '...'}`"
        />
      </v-col>
      <v-col sm="6" cols="12">
        <InfoBlock
          v-if="currentStage > 2"
          :label="$t('upcoming.allocation')"
          :data="`
              ${amountFilter(info.currentAllocation > 0 ? info.stakeAllocationAmount : 0, 5)}
              ${info.paymentToken || '...'}`"
          :list="[
            `Left to buy - ${amountFilter(
              info.currentAllocation > 0 ? $BN(info.leftToBuy) : '0',
              5,
            )} ${info.paymentToken || '...'}`,
            `Bought - ${amountFilter(isNaN(info.bought) ? 0 : info.bought, 5)} ${
              info.paymentToken || '...'
            }`,
          ]"
        />
        <InfoBlock
          v-else
          :label="$t('upcoming.allocation')"
          :data="`
            ${amountFilter(info.currentAllocation > 0 ? info.stakeAllocationAmount : 0, 5)}
            ${info.paymentToken || '...'}`"
          :list="[
            `Allocation - ${amountFilter(
              info.currentAllocation > 0
                ? $BN((info.tokenAmount * info.allocationPercent) / 100)
                : '0',
              5,
            )} ${info.token || '...'}`,
            `For your participant stake share - ${amountFilter(
              info.currentAllocation ? $BN(info.currentAllocation) : 0,
              5,
            )} ${token}`,
            `Your total stake - ${amountFilter(info.stake ? $BN(info.stake) : 0, 5)} ${token}`,
            `Minimum stake - ${amountFilter(info.minStake ? $BN(info.minStake) : 0, 5)} ${token}`,
            `Maximum stake - ${amountFilter(
              info.maximumStake ? $BN(info.maximumStake) : 0,
              5,
            )} ${token}`,
            `Total / max participants - ${info.participants} / ${
              Number(info.maxParticipants) > 9999 ? 'unlimited' : info.maxParticipants
            }`,
          ]"
        />
      </v-col>
    </v-row>
  </div>
</template>

<style lang="scss"></style>
